import ChatComponent from 'components/Message/ChatComponent/ChatComponent';
import ContainerComponent from 'components/Tool/ContainerComponent/ContainerComponent';
import Footer from 'pages/Client/Footer/Footer';
import Header from 'pages/Client/Header/Header';
import './Chat.css';

function Chat() {
  return (
    <>
      <div className="chat layout-full-height">
        <Header />

        <ContainerComponent className="layout-main-content-flex">
          <ChatComponent />
        </ContainerComponent>

        <Footer />
      </div>
    </>
  );
}

export default Chat;
